import { useEffect } from 'react';
import { TextField, Grid } from '@mui/material';
import TooltipReusable from 'src/components/TooltipReusable';
import { useField } from 'formik';
import QuestionLayout from './QuestionLayout';
import BANK from 'src/config/bank';
import { useAppDispatch } from 'src/utils/hooks';
import { updateChildVisibility } from 'src/store/reducers/riskCheck.reducer';

interface Props {
  question: Question;
  riskIdx: number;
  personIdx: number;
}

export default function OrderQuestion({ question, riskIdx, personIdx }: Props) {
  const dispatch = useAppDispatch();
  const [field, meta] = useField(
    question.key.replace(/\./g, '&').replace(/\[\]/g, '$')
  );
  const [, , helpersBank] = useField('orderBankName');
  useEffect(() => {
    if (field.value) {
      const name = BANK[field.value.substring(4, 12)];
      helpersBank.setValue(name);
    }

        if ( question.expChild && field.value !== undefined && field.value !== null ) {
              const regex = new RegExp(question.expChild);
              const isMatch = regex.test(field.value);
              const visible = question.expChildCheckPositive === isMatch;
              const key = question.key;
              dispatch(
                updateChildVisibility({
                  visible,
                  key,
                  riskIdx,
                  personIdx: personIdx - 1,
                })
              );
            }
    
    // eslint-disable-next-line
  }, [field.value]);
  return (
    <QuestionLayout question={question} meta={meta}>
      <Grid item minWidth={'100%'}>
        <TextField
          error={meta.touched && Boolean(meta.error)}
          {...field}
          hiddenLabel
          fullWidth
          disabled={question.readonly}
          variant="filled"
          sx={{
            backgroundColor: 'inputFields.bgColor',
            input: {
              color: 'inputFields.main',
            },
            '.MuiInputBase-root': {
              backgroundColor: 'inputFields.bgColor',
            },
            '.MuiSvgIcon-root': {
              color: 'inputFields.main',
            },
            '& .MuiFilledInput-root:before': {
              borderBottom: (theme) =>
                `1px solid ${theme.palette.inputFields?.main || '#000000'}`,
            },
            '& .MuiFilledInput-root:after': {
              borderBottom: (theme) =>
                `1px solid ${theme.palette.inputFields?.main || '#000000'}`,
            },
            '& .Mui-disabled': {
              backgroundColor: 'inputFields.bgColor',
            },
            label: {
              color: 'inputFields.main',
            },
            ...(question.readonly && {
              '& .MuiFilledInput-root:before': {
                borderBottom: 'none',
              },
              '& .MuiFilledInput-root:after': {
                borderBottom: 'none',
              },
            }),
          }}
        />
      </Grid>
      <Grid item paddingLeft={'20px'}>
        {question.answer.prefilled && !question.readonly && (
          <TooltipReusable
            title={[
              'Diese Angabe wurde aus Ihren vorherigen Angaben übernommen. Bitte überprüfen Sie diese auf Korrektheit.',
            ]}
            iconFlag={false}
          />
        )}
      </Grid>
    </QuestionLayout>
  );
}
